module.exports = __webpack_public_path__ + "img/bandera.4cfb32de.png";